import { useState, useEffect, useRef } from "react";
export default function CoreFeaturesBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "#FFFFFF",
    width: "100%"
  }} className="!bg-transparent">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
        .cursor-blink {
          animation: blink 1s step-end infinite;
          display: inline-block;
          margin-left: 1px;
        }
        .banner-animate {
          transition: opacity 0.5s cubic-bezier(0.12, 0.23, 0.5, 1) 0.09s, transform 0.5s cubic-bezier(0.12, 0.23, 0.5, 1) 0.09s;
        }
        .banner-animate.hidden-state {
          opacity: 0;
          transform: translateY(30px);
        }
        .banner-animate.visible-state {
          opacity: 1;
          transform: translateY(0px);
        }
      `}</style>

      <div ref={ref} className={`banner-animate transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${visible ? "visible-state" : "hidden-state"}`} style={{
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(20, 21, 31)",
      fontFamily: '"Evergrow Sans", "Inter", sans-serif',
      animation: "none 0s ease 0s 1 normal none running",
      margin: "152px 0px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "16px",
      textAlign: "center",
      paddingInline: "16px"
    }}>
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683000/img/stars.svg" alt="AI Stars" style={{
          width: "16px",
          height: "16px",
          display: "block"
        }} />
          <span style={{
          fontFamily: '"Evergrow Sans", "Inter", sans-serif',
          fontSize: "16px",
          fontWeight: 400,
          color: "rgb(20, 21, 31)",
          lineHeight: "1"
        }}>Built right, from day one</span>
        </div>

        <h2 style={{
        color: "rgb(20, 21, 31)",
        fontFamily: '"Evergrow Sans", "Inter", sans-serif',
        fontSize: "clamp(32px, 5vw, 64px)",
        fontWeight: "700",
        lineHeight: "1.25",
        border: "0px none rgb(20, 21, 31)",
        textAlign: "center",
        animation: "none 0s ease 0s 1 normal none running",
        letterSpacing: "-0.02em",
        margin: 0,
        maxWidth: "900px"
      }} className="!font-medium">Fast, secure, and SEO-ready without you ever touching the settings.</h2>
      </div>
    </section>;
}